const cleanButton = `
  position: relative;
  border: 0px;
  padding: 0px;
  margin: 0px;
  background-color: #ffffff;
  color: rgba(0, 0, 24, 0.48);
  font-size: 14px;
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
  outline: 0;
  display: flex;
  align-items: center;
	justify-content: center;
	
	&:hover {
		background: rgba(0, 0, 24, 0.08);
		border-radius: 50px;
	}
`;
const activePage = theme => `
  content: '';
  display: block;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  background-color: ${theme.colors.secondary.lighten};
  border-radius: 8px;
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 0;
  top: 0;
	left: 0;
`;
const disabled = `
	&:disabled,
	&[disabled] {
		background: #f5f5f5;

		i:before {
			background-color: #c3c2c8;
		}
	}
`;
export const makePaginationComponent = () => {
    return `display: flex;
					align-items: center;
					justify-content: center;
					min-height: 92px;
	`;
};
export const makePagesList = props => {
    const { theme } = props;
    return `margin: 0px;
					padding: 0px 4px;
					border-radius: 50px;
					display: flex;
					align-items: center;
					background-color: #ffffff;
					height: 24px;

					button {
						font-family: ${theme.fonts.families.primary};
					}
	`;
};
export const makePageLink = props => {
    const { isActive, theme } = props;
    return `${cleanButton}
					${isActive &&
        `width: 28px;
						 height: 28px;	
						 position: relative;

						 span {
							position: relative;
							z-index: 2;
							font-weight: 600;
							font-size: 16px;
							color: white;
						 }

					&:after {
						${activePage(theme)}
					}`}
	`;
};
export const makePrevPage = () => {
    return `${cleanButton}
					height: 24px;
					margin-right: 16px;
					border-radius: 50%;
					${disabled}
	`;
};
export const makeNextPage = () => {
    return `${cleanButton}
					height: 24px;
					margin-left: 16px;
					border-radius: 50%;
					${disabled}
	`;
};
export const makeEtc = () => {
    return `font-size: 14px;
					line-height: 24px;
					width: 24px;
					height: 24px;
					text-align: center;
	`;
};
